import type { BoxProps } from '@talos/kyoko';
import { Box, MarketColorDot, MarketColorDotVariant, Text } from '@talos/kyoko';
import { useTheme } from 'styled-components';
import { SelectedMarketsWrapper } from '../styles';

interface SelectedMarketsProps extends BoxProps {
  marketNames: string[];
}

export function SelectedMarkets({ marketNames, ...props }: SelectedMarketsProps) {
  const theme = useTheme();

  return (
    <SelectedMarketsWrapper {...props}>
      <Text size="fontSizeSmall">
        Pricing from{' '}
        {marketNames.length > 0 ? `${marketNames.length} market${marketNames.length > 1 ? 's' : ''}` : 'all exchanges'}
      </Text>
      {marketNames.length > 0 ? (
        <SelectedMarketsDots marketNames={marketNames} borderColor={theme.backgroundContent} />
      ) : null}
    </SelectedMarketsWrapper>
  );
}

interface SelectedMarketsDotsProps {
  marketNames: string[];
  borderColor: string;
}

export function SelectedMarketsDots({ marketNames, borderColor }: SelectedMarketsDotsProps) {
  const theme = useTheme();

  return (
    <Box
      ml="spacing8"
      position="relative"
      w={`${(marketNames.length * theme.spacing8) / 1.5}px`}
      h={`${theme.indicatorDotSizeLarge}px`}
    >
      {marketNames.map((market, index) => {
        return (
          <Box
            key={market}
            position="absolute"
            style={{ left: `${(index * theme.spacing8) / 1.5}px`, top: '1px', zIndex: index + 1 }}
          >
            <MarketColorDot market={market} variant={MarketColorDotVariant.Bordered} borderColor={borderColor} />
          </Box>
        );
      })}
    </Box>
  );
}
